import css from '@styled-system/css';
import React, { useState } from 'react';
import styled from 'styled-components';
import { color, compose, layout, shadow, space } from 'styled-system';
import List from './List';
import MenuButton from './MenuButton';
import theme from '../theme';
const MenuList = styled(List) `
  ${css({
    background: 'white',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
    cursor: 'pointer',
    position: 'relative',
    margin: '0',
    top: '0',
    minWidth: '150px',
    zIndex: '1'
})}
  ${compose(color, layout, shadow, space)}
`;
function Menu({ children, label }) {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement("div", null,
        React.createElement(MenuButton, { label: label, onClick: () => {
                setIsOpen(!isOpen);
            } }),
        isOpen && React.createElement(MenuList, null, children)));
}
Menu.defaultProps = { theme };
export default Menu;
//# sourceMappingURL=Menu.js.map